import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface OrganizationDetails {
  id: string;
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryOrgApi = createApi({
  reducerPath: "registryOrgApi",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryOrganization"],
  endpoints: (build) => ({
    getRegistryOrganizationDetails: build.query<OrganizationDetails, string>({
      query: (id) => `/rs/registry/org/${id}`,
      providesTags: ["RegistryOrganization"],
    }),

  }),
});

export const { useGetRegistryOrganizationDetailsQuery } = registryOrgApi;
